'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIIconCircle;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _UIIconHolder = require('./UIIconHolder');

var _UIIconHolder2 = _interopRequireDefault(_UIIconHolder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UIIconCircle(props) {
  var borderColor = props.borderColor,
      className = props.className,
      color = props.color,
      iconClassName = props.iconClassName,
      legacy = props.legacy,
      padding = props.padding,
      rest = _objectWithoutProperties(props, ['borderColor', 'className', 'color', 'iconClassName', 'legacy', 'padding']);

  var outerCircleClassNames = (0, _classnames2.default)('private-icon-circle__outer', { 'private-icon-circle--legacy': legacy }, className);
  var innerCircleClassNames = (0, _classnames2.default)('private-icon-circle__inner', iconClassName);
  return _react2.default.createElement(_UIIconHolder2.default, _extends({}, rest, {
    borderColor: borderColor || color,
    borderRadius: '50%',
    className: outerCircleClassNames,
    innerClassName: innerCircleClassNames,
    padding: legacy ? 0 : padding,
    color: color
  }));
}

UIIconCircle.propTypes = {
  backgroundColor: _UIIconHolder2.default.propTypes.backgroundColor,
  borderColor: _UIIconHolder2.default.propTypes.borderColor,
  borderStyle: _UIIconHolder2.default.propTypes.borderStyle,
  borderWidth: _UIIconHolder2.default.propTypes.borderWidth,
  verticalAlign: _UIIconHolder2.default.propTypes.verticalAlign,
  innerStyles: _propTypes2.default.object,
  iconClassName: _propTypes2.default.string,
  name: _UIIconHolder2.default.propTypes.name,
  color: _propTypes2.default.string,
  size: _propTypes2.default.number,
  padding: _propTypes2.default.number,
  legacy: _propTypes2.default.bool
};

UIIconCircle.defaultProps = {
  borderWidth: 1,
  borderStyle: 'solid',
  padding: 0.75
};

UIIconCircle.displayName = 'UIIconCircle';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/icon/UIIconCircle.js
// module id = 560
// module chunks = 177